import { Col, Divider, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'translations/hooks';

import { Tasks } from 'business/shift-report/report/pages/ReportEdit/types';

export const NotEndedTasksWarning = ({
  notEndedTasks,
}: {
  notEndedTasks: Tasks;
}) => {
  const { t } = useTranslation();

  return (
    <>
      {t('pages.report.penultimateTastNotEnded')}

      <Row style={{ padding: '0 8px' }}>
        <Col span={6}>
          <Typography.Title level={5} style={{ width: '50%', marginTop: 16 }}>
            {t('pages.report.warning.task')}
          </Typography.Title>
        </Col>
        <Col span={6}>
          <Typography.Title level={5} style={{ marginTop: 16 }}>
            {t('pages.report.warning.ring')}
          </Typography.Title>
        </Col>
        <Col span={6}>
          <Typography.Title level={5} style={{ marginTop: 16 }}>
            {t('pages.report.warning.startTime')}
          </Typography.Title>
        </Col>
        <Col span={6}>
          <Typography.Title level={5} style={{ marginTop: 16 }}>
            {t('pages.report.warning.endTime')}
          </Typography.Title>
        </Col>
      </Row>

      {notEndedTasks.map((task) => {
        return (
          <>
            <Divider style={{ margin: '4px 0' }} />
            <Row style={{ padding: '0 8px' }}>
              <Col span={6}>{task.activity.name}</Col>
              <Col span={6}>{task.ring}</Col>
              <Col span={6}>{dayjs(task.startDate).format('HH:mm')}</Col>
              <Col span={6}>{dayjs(task.endDate).format('HH:mm')}</Col>
            </Row>
          </>
        );
      })}
    </>
  );
};
